export class admCatOccupationsGrid {
}